module.exports = __webpack_public_path__ + "img/euskera.0336adbe.svg";